
import { useStore } from "vuex";
import { computed } from "vue";

export default {
  setup() {
    const store = useStore(),
      config = computed(() => store.state.config.config),
      imgUrl = computed(
        () =>
          `${config.value.publicPath}branding/${
            process.env.NODE_ENV === "development"
              ? `${process.env.VUE_APP_BRANDING_DIRECTORY}/`
              : ""
          }powered-by-light.svg`
      );

    return {
      imgUrl
    };
  }
};
